import { postData_ } from 'helpers/Helper'
import { GET_API_VALIDITY_USER, GET_DASHBOARD_API_CALLS } from './apiPath'
import { getApiValidityUserCall, getDashboardApiCall } from 'store/actions/userDashboard';
import { persist_store } from 'store/actions/index';

export function getDashboardApiCalls(value, callback) {
    return (dispatch) => {
        dispatch(persist_store({ loader: true }));
        return postData_(`${GET_DASHBOARD_API_CALLS}`, value)
            .then((data) => {
                dispatch(getDashboardApiCall(data, callback));
                dispatch(persist_store({ loader: false }));
                return data;
            })
            .catch(error => {
                dispatch(persist_store({ loader: false }));
                console.error('Error fetching data:', error);
            });
    };
};


export function getApiValidityUserData(value, callback) {
    return (dispatch) => {
        dispatch(persist_store({ loader: true }));
        return postData_(`${GET_API_VALIDITY_USER}`, value)
            .then((data) => {
                dispatch(getApiValidityUserCall(data, callback));
                dispatch(persist_store({ loader: false }));
                return data;
            })
            .catch(error => {
                dispatch(persist_store({ loader: false }));
                console.error('Error fetching data:', error);
            });
    };
}